export enum RegistrationFooterContent {
  POWERED_BY = "POWERED_BY",
  COOKIES = "COOKIES"
}
